module.exports = __webpack_public_path__ + "media/images/banners/main2-9ab01a013b81019eb318548cc72ade7c.jpg";